/* eslint-disable max-len */
import React from 'react';
function WbSunnyOutlined() {
    return (React.createElement("g", null,
        React.createElement("path", { d: "M6.76 4.84l-1.8-1.79-1.41 1.41 1.79 1.79zM1 10.5h3v2H1zM11 .55h2V3.5h-2zM19.0404 3.045l1.4072 1.407-1.789 1.789-1.4071-1.4071zM17.24 18.16l1.79 1.8 1.41-1.41-1.8-1.79zM20 10.5h3v2h-3zM12 5.5c-3.31 0-6 2.69-6 6s2.69 6 6 6 6-2.69 6-6-2.69-6-6-6zm0 10c-2.21 0-4-1.79-4-4s1.79-4 4-4 4 1.79 4 4-1.79 4-4 4zM11 19.5h2v2.95h-2zM3.55 18.54l1.41 1.41 1.79-1.8-1.41-1.41z" })));
}
export default WbSunnyOutlined;
